export const BIZ_DEV_API_URL = "https://dev.mintup.kr:8081";
export const BIZ_TEST_API_URL = "https://test.mintup.kr:8081";
export const BIZ_LIVE_API_URL = "https://mint.mintup.kr:8081";

export const COMMON_DEV_API_URL = "https://dev.mintup.kr:8081";
export const COMMON_TEST_API_URL = "https://test.mintup.kr:8081";
export const COMMON_LIVE_API_URL = "https://mint.mintup.kr:8081";

export const IMAGE_DEV_API_URL = "https://dev.mintup.kr:8081";
export const IMAGE_TEST_API_URL = "https://test.mintup.kr:8081";
export const IMAGE_LIVE_API_URL = "https://image.mintup.kr:8081";
